/**
 * @fileoverview A generic helper for localizing strings content.
 */

import React from 'react'
import Presenter from 'microcosm/addons/presenter'
import Polyglot from 'node-polyglot'
import { get } from 'microcosm'

class i18n extends Presenter {
  static defaultProps = {
    // React requires us to wrap the string in a tag. What tag should
    // we use?
    tag: 'span',
    // Where from repo state should we pull translations?
    source: 'locale'
  }

  getModel({ source }) {
    return {
      phrases: data => get(data, source, {})
    }
  }

  translate(word) {
    const { phrases } = this.model

    return Polyglot.transformPhrase(`${word}`, phrases)
  }

  render() {
    const { tag: Tag, children, repo, source, ...props } = this.props

    return <Tag {...props}>{this.translate(children)}</Tag>
  }
}

export default i18n



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/i18n.js